import { c as _c } from "react/compiler-runtime";
import { IcoRepeat40, IcoWarning16 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import { useTimeout } from 'usehooks-ts';
import { TRANSITION_DELAY_LONG } from '../../constants';
import FadeInContainer from '../fade-in-container';
import FeedbackIcon from '../feedback-icon';
import NavigationHeader from '../navigation-header';
type RetryLimitExceededProps = {
  onRetryLimitExceeded: () => void;
  variant?: 'document' | 'selfie';
};
const RetryLimitExceeded = t0 => {
  const $ = _c(17);
  const {
    onRetryLimitExceeded,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "document" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "document-flow.components.retry-limit-exceeded"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t2);
  let t3;
  if ($[1] !== t || $[2] !== variant) {
    t3 = variant === "selfie" ? t(_temp) : t(_temp2);
    $[1] = t;
    $[2] = variant;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const description = t3;
  let t4;
  if ($[4] !== onRetryLimitExceeded) {
    t4 = () => {
      onRetryLimitExceeded();
    };
    $[4] = onRetryLimitExceeded;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useTimeout(t4, TRANSITION_DELAY_LONG);
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NavigationHeader />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeedbackIcon imageIcon={{
      component: IcoRepeat40,
      color: "primary"
    }} statusIndicator={{
      component: <IcoWarning16 color="error" />,
      status: "error"
    }} />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = t(_temp3);
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <div className="text-label-1 text-error text-center">{t7}</div>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== description) {
    t9 = <div className="text-body-2 text-secondary text-center">{description}</div>;
    $[12] = description;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <FadeInContainer><div className="flex flex-col justify-center items-center gap-4">{t5}{t6}<div className="flex flex-col justify-center items-center gap-2">{t8}{t9}</div></div></FadeInContainer>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export default RetryLimitExceeded;
function _temp($) {
  return $["description-selfie"];
}
function _temp2($_0) {
  return $_0.description;
}
function _temp3($_1) {
  return $_1.title;
}